module.exports = __webpack_public_path__ + "img/3.f84519b4.png";